import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=41cde4b5&scoped=true"
import script from "./EditTask.vue?vue&type=script&lang=js"
export * from "./EditTask.vue?vue&type=script&lang=js"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=41cde4b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cde4b5",
  null
  
)

export default component.exports